var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{staticClass:"byline",attrs:{"name":"byline","location":"main","is-tertiary":"","data-cy":"bylineButton"},on:{"click":function($event){return _vm.showModal('about')}}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }